import {
  WbHeaderActionButton,
  WittyChat,
  WittyIcon,
} from '@agilelab/plugin-wb-platform';
import { makeStyles } from '@material-ui/core';
import { useWittyAssistant } from '../../contexts/useWittyAssistant';

const useStyles = makeStyles(theme => ({
  expandingChat: {
    position: 'absolute',
    top: 0,
    right: 0,
    justifySelf: 'flex-end',
    height: '100vh',
    width: '40vw',
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
    },
  },
  expandedChat: {
    position: 'absolute',
    top: 0,
    right: 0,
    justifySelf: 'flex-end',
    height: '100vh',
    width: '70vw',
    [theme.breakpoints.down('xs')]: {
      width: '100vw',
    },
  },
}));

export const WittyAssistant = () => {
  const classes = useStyles();

  const {
    loading,
    messages,
    open,
    onNewMessage,
    setOpen,
    expanded,
    setExpanded,
    onNewSession,
  } = useWittyAssistant();

  return (
    <>
      {open ? (
        <div
          className={expanded ? classes.expandedChat : classes.expandingChat}
        >
          <WittyChat
            incomingMessage={loading}
            messages={messages}
            onNewMessage={onNewMessage}
            onNewSession={onNewSession}
            setOpen={setOpen}
            setChatExpanded={() =>
              setExpanded((prevExpanded: boolean) => !prevExpanded)
            }
            isMicrophoneActive={false}
            isAttachContentActive={false}
            isFeedbackActive={false}
          />
        </div>
      ) : (
        <WbHeaderActionButton
          aria-label="Open Witty Chat"
          icon={<WittyIcon />}
          onClick={() => {
            setExpanded(false);
            setOpen(true);
          }}
        />
      )}
    </>
  );
};
